import React, { useCallback, useContext, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { VideoPlayButton } from './VideoPlayButton';
import './video-hero-image.scss';

export const VideoPlayer = ({ 
  mobileVideoUrl = null, desktopVideoUrl = null, altText = 'Video content', videoClasses = '', mobilePosterImageUrl = null, desktopPosterImageUrl = null,
  shouldLoopVideo = true, prioritizeMedia = false
}) => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(true);
  const [showReplay, setShowReplay] = useState(false);

  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  const posterImageUrl = isMobile ? mobilePosterImageUrl : desktopPosterImageUrl;

  const handlePlayPause = useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsPlaying((prev) => {
      if (prev) {
        videoRef?.current?.pause();
      } else {
        videoRef?.current?.play();
      }
      return !prev;
    });
    if (showReplay) setShowReplay(false);
  }, [showReplay]);

  const handleVideoEnded = () => {
    if (!shouldLoopVideo) {
      setShowReplay(true);
      setIsPlaying(false);
    }
  };

  return (
    <div className="video-hero-image sui-relative sui-w-full sui-h-full" data-component="VideoPlayer">
      <video
        ref={videoRef}
        className={videoClasses}
        aria-label={altText}
        autoPlay
        onEnded={handleVideoEnded}
        playsInline
        poster={posterImageUrl}
        preload={prioritizeMedia ? 'auto' : 'metadata'}
        muted
        loop={shouldLoopVideo}
        controls=""
      >
        {desktopVideoUrl && (
          <source
            src={desktopVideoUrl}
            type="video/mp4"
            media="(min-width: 1024px)"
          />
        )}
        {mobileVideoUrl && (
          <source
            src={mobileVideoUrl}
            type="video/mp4"
          />
        )}
      </video>
      <VideoPlayButton
        handlePlayChange={handlePlayPause}
        isPlaying={isPlaying}
        shouldShowReplay={showReplay}
      />
    </div>
  );
};
VideoPlayer.propTypes = {
  mobileVideoUrl: PropTypes.string,
  desktopVideoUrl: PropTypes.string,
  altText: PropTypes.string,
  videoClasses: PropTypes.string,
  mobilePosterImageUrl: PropTypes.string,
  desktopPosterImageUrl: PropTypes.string,
  shouldLoopVideo: PropTypes.bool,
  prioritizeMedia: PropTypes.bool,
};
